export default __webpack_public_path__ + "static/media/face-dead.becf8ac4.svg";